import useMixedItemDist from "./useMixedItemDist";

export const useTotalItemCount = () => {
	const { data } = useMixedItemDist();
	return data?.contents?.reduce((acc, curr) => acc + curr.totalCount, 0) ?? 0;
};
